<template>
  <div v-if="isExternalLink">
    <a :href="url" :class="classList">
      <i :class="classIcon"></i> {{name}}
      <b-badge v-if="badge && badge.text && noContract" :variant="badge.variant">{{badge.text}}</b-badge>
    </a>
  </div>
  <div v-else>
    <router-link :to="url" :class="classList">
      <i :class="classIcon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      <b-badge v-if="badgeState1 && noContract && appIsSetup" :variant="badgeState1.variant">{{badgeState1.text}}</b-badge>
      <b-badge v-if="badgeState2 && !noContract && appIsSetup" :variant="badgeState2.variant">{{badgeState2.text}}</b-badge>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
    badgeState1: {
      type: Object,
      default: () => {}
    },
    badgeState2: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    superAdmin: {
     type: String,
      default: ''
    }
  },
  computed: {
    classList () {
      return [
        'nav-link',
        this.linkVariant,
        ...this.itemClasses
      ]
    },
    classIcon () {
      return [
        'nav-icon',
        this.icon
      ]
    },
    linkVariant () {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses () {
      return this.classes ? this.classes.split(' ') : []
    },
    isExternalLink () {
      if (this.url.substring(0, 4) === 'http') {
        return true
      } else {
        return false
      }
    },
    noContract () {
      return this.$store.getters.noContract;
    },
    appIsSetup () {
      return this.$store.state.appIsSetup;
    },
    isAdmin () {
      return this.$store.getters.isAdmin;
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin;
    }
  }
}
</script>